import { Component } from '@angular/core';

@Component({
  selector: 'app-reset-password-invalid',
  templateUrl: './reset-password-invalid.component.html',
  styleUrls: ['./reset-password-invalid.component.css']
})
export class ResetPasswordInvalidComponent { }



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.ts